import { Box } from '@mui/material';
import { 
  HeroCarousel, 
  InfoSection, 
  FeaturedProducts, 
  InstagramFeed 
} from '../components/home';
import { homeAnimations } from '../styles/animations';
import SEO from '../components/SEO';
import { generatePageSEO } from '../utils/seoUtils';

const Home = () => {
  const seoData = generatePageSEO('home');
  
  return (
    <>
      <SEO
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        url={seoData.url}
        type={seoData.type}
      />
      <Box sx={homeAnimations}>
        <HeroCarousel />
        <InfoSection />
        <FeaturedProducts />
        <InstagramFeed />
      </Box>
    </>
  );
};

export default Home; 